export const appendFormData = (formData, data, parentKey = '') => {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const formKey = parentKey ? `${parentKey}[${key}]` : key;

      if (typeof data[key] === 'object' && !(data[key] instanceof File)) {
        appendFormData(formData, data[key], formKey);
      } else {
        formData.append(formKey, data[key]);
      }
    }
  }
}
